import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import ViewGuideMain from "../../../components/candidate/preparation/ViewGuideMain";

function ViewGuide() {
  const [guideDetails, setGuideDetails] = useState();
  const guideData = (value) => {
    setGuideDetails(value);
  };
  return (
    <div className="hirePlusPlusPageContent ">
      <Sidebar
        activePage="viewGuide"
        collapseSidbar="left"
        userRole="candidate"
      />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          activePage="viewGuide"
          userRole="candidate"
          newTitle={guideDetails?.jobTitle}
          // driverFlag="viewSingleGuide"
        />
        <ViewGuideMain guideData={guideData} />
      </div>
    </div>
  );
}

export default ViewGuide;
